"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GenericLogType = void 0;
var GenericLogType;
exports.GenericLogType = GenericLogType;

(function (GenericLogType) {
  GenericLogType["CALCULATED_VALUE"] = "calculatedValue";
  GenericLogType["EMISSION_FACTOR"] = "emissionFactor";
  GenericLogType["LIMIT_ITEM"] = "limitItem";
  GenericLogType["LOGGED_ITEM"] = "loggedItem";
  GenericLogType["ROLLING_CALCULATION"] = "rollingCalculation";
  GenericLogType["UNIT_CONVERSION"] = "unitConversion";
})(GenericLogType || (exports.GenericLogType = GenericLogType = {}));